import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { applyMiddleware, compose, createStore, combineReducers } from 'redux';
import { baseApiReducer } from '../TCSMApp/global/ducks/base-api';
import { globalizationReducer } from '../TCSMApp/global/ducks/globalization';
import { appContextApiReducer } from './global/ducks/app-context';
import { EcdEpiApiReducer } from './global/ducks/epi-api';
import { apiMiddleware } from './global/middleware/api-middleware';
import { EcdApp } from './root/ecd-app';
import { EcdStates } from './root/ecd-model';

const stateReducer = combineReducers<EcdStates>({
	apiState: baseApiReducer,
	authenticatedState: null,
	globalization: globalizationReducer,
	epiProps: EcdEpiApiReducer,
	appContext: appContextApiReducer,
});

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const stateStore = createStore(stateReducer, composeEnhancers(
	applyMiddleware(
		apiMiddleware,
	),
));

const mount = document.getElementById('ecd-root');
if (mount) {
	const appSettings = (window as any).bootstrap;

	ReactDOM.render(		
		<Provider store={stateStore}>
			<BrowserRouter>					
					<Switch>							
						<Route>
							<EcdApp appConfig={appSettings} />									
						</Route>
					</Switch>					
			</BrowserRouter>		
		</Provider>, mount,
	);
}